import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { SwipeableDrawer } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CancelIcon from '@material-ui/icons/Cancel';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import IconButton from '@material-ui/core/IconButton';

import globals from '../../../../globals/communityGlobals';
import { useFetchClinicianGroupsOnDay } from '../../../../actions/areas/clinicianGroups/fetchClinicianGroups';

export default function ClinicianGroupsOnDay({ isOpen, onClose, onSave, excludedGroups }) {
  const [componentState, setComponentState] = useState([]);
  const { data: clinicianGroups } = useFetchClinicianGroupsOnDay(false);

  const locale = globals.getAreas(['clinicianGroups', 'userActions']);

  useEffect(() => {
    if (clinicianGroups.mappedClinicianGroups)
      setComponentState(
        clinicianGroups.mappedClinicianGroups
          .filter(x => x.isValidOnDay && !excludedGroups.includes(x.id))
          .map(x => x.id),
      );
  }, [clinicianGroups]);

  if (!clinicianGroups.mappedClinicianGroups) return null;

  const handleClick = groupId => {
    if (componentState.findIndex(x => x === groupId) !== -1) {
      setComponentState(componentState.filter(x => x !== groupId));
      return;
    }
    const newState = [...componentState];
    newState.push(groupId);
    setComponentState(newState);
  };

  const onConfirm = () => {
    const groupsToExclude = clinicianGroups.mappedClinicianGroups
      .filter(x => !componentState.includes(x.id))
      .map(x => x.id);
    onSave(groupsToExclude);
  };

  const clinicianGroupRender = group => {
    const groupClass = classNames('clinician-group-item', {
      'selected-group': componentState.findIndex(x => x === group.id) !== -1,
      'invalid-group': !group.isValidOnDay,
    });
    return (
      <Box
        className={groupClass}
        disabled={!group.isValidOnDay}
        onClick={() => handleClick(group.id)}
        key={`${group.id}_${group.name}`}
      >
        <Box>
          <Typography className="ellipsis patientName" variant="h4">
            {group.name}
          </Typography>
        </Box>
        <Box>
          <Typography className="patientName" variant="h5">
            {group.clinicianNames}
          </Typography>
        </Box>
        {!group.isValidOnDay && (
          <div className="error-msg">
            <ReportProblemIcon className="icon-warning-style" />
            <span>{group.reasonMsg}</span>
          </div>
        )}
      </Box>
    );
  };

  const contentRender = () => {
    return (
      <div className="sidePanel-content content-top-padding">
        <Typography variant="h6" gutterBottom>
          {locale.getMsg('validClinicianGroupsOnDay')}
        </Typography>
        {clinicianGroups.mappedClinicianGroups.length > 0 ? (
          <div className="clinician-group-list">{clinicianGroups.mappedClinicianGroups.map(clinicianGroupRender)}</div>
        ) : (
          <div className="no-data-content">
            <div className="no-data-description">{locale.getMsg('noValidClinicianGroupsOnDay')}</div>
          </div>
        )}
      </div>
    );
  };

  const headerRender = () => {
    return (
      <div className="sidePanel-header form-header">
        <div className="sidePanel-header-subtitle">
          <Box display="flex">
            <Box flexGrow={1} py={1}>
              <Typography variant="subtitle1">{locale.getMsg('clinicianGroups')}</Typography>
            </Box>
            <Box>
              <IconButton onClick={onClose}>
                <CancelIcon />
              </IconButton>
            </Box>
          </Box>
        </div>
      </div>
    );
  };

  const footerRender = () => {
    return (
      <div className="sidePanel-footer">
        <div className="sidePanel-buttons">
          <div className="sidePanel-BackButton">
            <Button variant="contained" color="secondary" onClick={onClose} style={{ marginRight: '10px' }}>
              {locale.getMsg('back')}
            </Button>
          </div>
          <div className="sidePanel-saveButton">
            <Button
              variant="contained"
              color="primary"
              onClick={onConfirm}
              disabled={clinicianGroups.mappedClinicianGroups.length <= 0}
            >
              {locale.getMsg('save')}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <section className="side-panel-content-wrapper">
      <SwipeableDrawer anchor="right" open={isOpen} onOpen={() => {}} onClose={() => {}}>
        <div className="sidePanel-wrapper" style={{ width: '350px' }} id="groups-day-side-panel">
          {headerRender()}
          {contentRender()}
          {footerRender()}
        </div>
      </SwipeableDrawer>
    </section>
  );
}
